import { client } from "./client";
import interceptors from "./interceptors";
import qs from 'qs';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSDO(params) {
	return client.get("api/sdo/data", {
		params: params,
	});
}

function exportSDO(params) {
	return client.get("api/sdo/export", {
		params: params,
	});
}

function getSDOAll(params) {
	return client.get("api/sdo/all", {
		params: params,
	});
}

function exportSDOAll(params) {
	return client.get("api/sdo/export-all", {
		params: params,
	});
}

function getDetailSDO(params) {
	return client.get("api/sdo/detail", {
		params: {
			sdo_code : params
		},
	});
}

function getSOPaid() {
	return client.get("api/sdo/data-paid");
}

function getSOApproved() {
	return client.get("api/sdo/data-approved");
}

function getSDOStatus() {
	return client.get("api/options/sdo-status");
}

function deliverySDO(params) {
	return client.post("api/sdo/monitor", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

function createSDO(params) {
	return client.post("api/sdo/create", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

function scanSerial(params) {
	return client.post("api/sdo/scan", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

export default {
	getSDO,
	exportSDO,
	exportSDOAll,
	getSDOAll,
	getDetailSDO,
	getSOPaid,
	getSOApproved,
	getSDOStatus,
	createSDO,
	deliverySDO,
	scanSerial
};